module.exports = __webpack_public_path__ + "img/twitter.fa24d680.svg";